import React, { useEffect, useState } from 'react';
import { Button, Col, Row } from 'reactstrap';
import { useNavigate } from 'react-router-dom';

//Components
import Loading from '../../../components/Loading/Loading';
import MainCard from '../../../components/MainCard/MainCard';
import TextField from '../../../components/TextField/TextField';
import RelatorioTransportadoresContratosGeradores from './RelatorioTransportadoresContratosGeradores';

//Helpers
import { objCampo, validarCampos } from '../../../helpers/ValidadorDeCampos';
import { showMessage } from '../../../helpers/message';
import mascaras from '../../../helpers/mascaras';

//Api
import relatorio_api from '../../../api/relatorio_api';
import modalidadeColeta_api from '../../../api/modalidadeColeta_api';
import transportador_api from '../../../api/transportador_api';

// import { Container } from './styles';
function initialStateFiltros() {
  return {
    modalidadeId: 0,
    modalidadeId_selected: { value: 0, label: "Todos" },
    transportadorId: 0,
    transportadorId_selected: { value: 0, label: "Todos" },
    nomeRelatorio: "Relatório - Transportadores com Contratos por Geradores"
  }
}

function TransportadoresContratosGeradores() {
  //Estado que valida os possiveis erros nos campos de filtros
  const [errors, setErrors] = useState({});

  //Guarda os filtros obrigatorios
  const campos = [
    objCampo({ name: "transportadorId_selected", required: true }),
    objCampo({ name: "modalidadeId_selected", required: true })
  ];

  //Estado de controle do loading na tela
  const [loading, setLoading] = useState();

  //Estado que guarda os valores dos filtros
  const [filtros, setFiltros] = useState(initialStateFiltros());

  //Opções de modalidades de coleta
  const [optionsModalidades, setOptionsModalidades] = useState([]);

  //Estado que guarda os dados do relatorio
  const [dadosRelatorio, setDadosRelatorio] = useState(null);

  //Opções de transportadores
  const [optionsTransportadores, setOptionsTransportadores] = useState([]);

  //Variavel de navegação na tela
  const navigate = useNavigate();

  //Change para os campos modalidade e transportadores
  const onChangeSelected = (e, select) => {
    const { name } = select;
    setFiltros({
      ...filtros,
      [name]: e,
      [name.split("_")[0]]: e ? e.value : 0
    });
  }

  const loadTransportadores = () => {
    transportador_api.GetAll().then(response => {
        response.data = response.data.map(value => {
            value.value = value.id;
            value.label = value.fantasia;
            return value;
        });
        setOptionsTransportadores([{ value: null, label: "Todos" }, ...response.data]);
      })
      .catch(e => showMessage("Aviso", e.message, "error", null))
      .finally(f => setLoading(false));
  }

  const loadModalidades = () => {
    setLoading(true);
    modalidadeColeta_api.GetList().then(response => {
      response.data = response.data.map(value => {
        return { value: value.id, label: value.descricao };
      });
      setOptionsModalidades([{ value: null, label: "Todos" }, ...response.data]);
    }).catch(e => showMessage("Aviso", e.message, "error", null))
      .finally(f => setLoading(false));
  }

  //Função que puxa os dados do relatorio
  const carregarRelatorio = () => {
    const _errors = validarCampos(filtros, campos);
    if (_errors[1].length > 0) {
      setErrors(_errors[0]);
      return;
    }

    setLoading(true);
    relatorio_api.TransportadoresComContratosGeradores(filtros)
      .then(response => {
        response.data = response.data.map(value => {
          value.cnpjGerador = mascaras.cpfcnpjMask(value.cnpjGerador)
          value.cnpjTransportador = mascaras.cpfcnpjMask(value.cnpjTransportador)
          return value;
        });
        setDadosRelatorio(response.data);
      })
      .catch(e => showMessage("Aviso", e.message, "error", null))
      .finally(f => setLoading(false));
  }

  const handleVolta = () => {
    setDadosRelatorio(null);
    setFiltros(initialStateFiltros());
  }

  useEffect(() => {
    loadModalidades();
    loadTransportadores();
  }, []);

  if (dadosRelatorio) {
    return <RelatorioTransportadoresContratosGeradores
      btnVoltar={handleVolta}
      filtros={filtros}
      dadosRelatorio={dadosRelatorio}
    />
  }

  return (
    <MainCard btnVoltarInTop={() => navigate(-1)}>
      {loading && <Loading />}
      <h4>Relatório Transportadores com Contratos por Geradores</h4>
      <Row sm="12" md="6" lg="4">
        <Col sm="12" md="6" lg="4">
          <TextField
            placeholder='Selecione'
            name="modalidadeId_selected"
            label={"* Modalidade"}
            type={"select"}
            searchable
            value={filtros?.modalidadeId_selected}
            invalid={!!errors.modalidadeId_selected}
            onChange={onChangeSelected}
            options={optionsModalidades}
          />
        </Col>
        <Col sm="12" md="6" lg="4">
          <TextField
            placeholder='Selecione'
            name="transportadorId_selected"
            label={"* Transportador"}
            type={"select"}
            searchable
            value={filtros?.transportadorId_selected}
            invalid={!!errors.transportadorId_selected}
            onChange={onChangeSelected}
            options={optionsTransportadores}
          />
        </Col>
        <Col sm="12" md="6" lg="3" style={{ marginTop: "1.875rem" }}>
          <Button
            className='w-100 fw-bold'
            color='info text-light'
            onClick={carregarRelatorio}>Gerar Relatório</Button>
        </Col>
      </Row>
    </MainCard>
  );
}

export default TransportadoresContratosGeradores;